import * as services from 'services/projects';
import { delateProjectApiKeys } from './apiKeys';

export const SET_ERROR = 'projects/SET_ERROR';
export const CLEAR_ERROR = 'projects/CLEAR_ERROR';
export const REQUEST_STARTED = 'projects/REQUEST_STARTED';
export const REQUEST_COMPLETED = 'projects/REQUEST_SUCCESSFUL';
export const SET_PROJECTS = 'projects/SET_PROJECTS';
export const SET_PROJECT = 'projects/SET_PROJECT';
export const EDIT_PROJECT = 'projects/EDIT_PROJECT';
export const GET_PROJECTS_FROM_SERVER = 'projects/GET_PROJECTS_FROM_SERVER';
export const DELETE_PROJECT = 'projects/DELETE_PROJECT';
export const ADD_PROJECT = 'projects/ADD_PROJECT';
export const SET_NEW_PROJECT_ID = 'projects/SET_NEW_PROJECT_ID';

export const setError = error => ({
  type: SET_ERROR,
  error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const requestStarted = () => dispatch => {
  dispatch(clearError());
  dispatch({ type: REQUEST_STARTED });
};

export const requestCompleted = () => ({
  type: REQUEST_COMPLETED,
});

export const setProjects = projects => ({
  type: SET_PROJECTS,
  projects,
});

export const setProject = project => ({
  type: SET_PROJECT,
  project,
});

export const setNewProjectId = newProjectId => ({
  type: SET_NEW_PROJECT_ID,
  newProjectId,
});

export const getProjectsFromServer = () => dispatch => {
  dispatch(requestStarted());
  services
    .getProjects()
    .then(projects => {
      dispatch(setProjects(projects));
      dispatch(requestCompleted());
    })
    .catch(() => {
      dispatch(setError('Error fetching projects'));
      dispatch(requestCompleted());
    });
};

export const addProject = project => dispatch => {
  dispatch(requestStarted());
  services
    .addProject(project)
    .then(({ success, id }) => {
      if (success) {
        dispatch(setNewProjectId(id));
        dispatch(getProjectsFromServer());
      } else dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};

export const editProject = project => dispatch => {
  dispatch(requestStarted());
  services
    .editProject(project)
    .then(({ success }) => {
      if (success) dispatch(getProjectsFromServer());
      else dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};

export const deleteProject = projectId => dispatch => {
  dispatch(requestStarted());
  dispatch(delateProjectApiKeys(projectId));
  services
    .deleteProject(projectId)
    .then(({ success }) => {
      if (success) dispatch(getProjectsFromServer());
      else dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};
